<ng-container *ngIf="data()?.children?.length">
    <mat-selection-list
        matSelectionList
        hideSingleSelectionIndicator
        class="st-assignments-overlay"
        [multiple]="false">
        <mat-list-option
            *ngFor="let assignment of data()?.children"
            [value]="assignment"
            (click)="onObjectOpen.emit(assignment)">
            <st-icon
                hasBorder
                class="st-assignments-overlay-icon"
                [type]="assignment?.PSTCoverageType?.toUpperCase()"
                [data]="assignment" />
            <st-avatar
                *ngIf="assignment.Owner"
                class="st-assignments-overlay-avatar"
                horizontal-big
                [userId]="getUserID(assignment)"
                [label]="playbookService.globalTablesService.FieldDefsDict[pstFieldNames?.PSTAssignmentOwner]?.DefaultCaption" />
        </mat-list-option>
    </mat-selection-list>
</ng-container>
